function escapeRegExp(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}

function setUpFormValidation() {
  const checks = document.querySelectorAll("#user_profile input[type='checkbox']");
  for (const c of checks) {
    c.addEventListener("change", function() {
      wm.validateUserProfile();
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  setUpFormValidation();
});
